export default __webpack_public_path__ + "static/media/logo-navy-with-tagline@2x.434db31e.png";